import { useMemo } from 'react';

import type { SelectOption } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

export enum DATA_DIRECTIONS {
  BOTH = '',
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}

export const useDirectionOptions = () => {
  const { t } = useTranslation('flow');

  return useMemo<SelectOption[]>(
    () => [
      { value: DATA_DIRECTIONS.BOTH, text: t('flowDirection.both') },
      { value: DATA_DIRECTIONS.INBOUND, text: t('flowDirection.inbound') },
      { value: DATA_DIRECTIONS.OUTBOUND, text: t('flowDirection.outbound') },
    ],
    [t],
  );
};
